/** The small spaced-out capitals above a heading. Colour comes from `className`. */
export default function Eyebrow({ className = '', ...props }) {
  return (
    <span
      className={`text-[12px] font-medium tracking-[.18em] uppercase ${className}`}
      {...props}
    />
  )
}
